import React, { useState } from 'react';
import { Clock, CheckCircle, Trash2, StickyNote, Video, Building2, MonitorPlay } from 'lucide-react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase-config';

const DashboardView = ({ appointments, filteredAppointments, loading, handleApprove, handleDelete }) => {
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [tempNote, setTempNote] = useState("");

  const saveNote = async (id) => {
    const aptRef = doc(db, "appointments", id);
    await updateDoc(aptRef, { note: tempNote });
    setEditingNoteId(null);
  };

  return (
    <div className="tab-pane anim-in">
      {/* Üst İstatistik Kartları */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon-box"><Clock size={24} /></div>
          <div>
            <h3>{appointments.filter(a => a.status !== 'Onaylandı').length}</h3>
            <p>Onay Bekleyen</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-box success"><CheckCircle size={24} /></div>
          <div>
            <h3>{appointments.filter(a => a.status === 'Onaylandı').length}</h3>
            <p>Onaylanan</p>
          </div>
        </div>
        {/* Yeni: Online Randevu Sayacı */}
        <div className="stat-card">
          <div className="stat-icon-box info" style={{ backgroundColor: '#e0f2f1', color: '#2AB2AF' }}>
            <MonitorPlay size={24} />
          </div>
          <div>
            <h3>{appointments.filter(a => a.type === 'Online').length}</h3>
            <p>Online Randevu</p>
          </div>
        </div>
      </div>

      <div className="table-wrapper desktop-only">
        <table className="apt-table">
          <thead>
            <tr>
              <th>Hasta Bilgisi</th>
              <th>Randevu Türü</th> {/* Yeni kolon */}
              <th>Notlar</th>
              <th>Zaman</th>
              <th>Durum</th>
              <th>Aksiyon</th>
            </tr>
          </thead>
          <tbody>
            {filteredAppointments.map(apt => (
              <tr key={apt.id} className={`apt-row status-${(apt.status || 'beklemede').toLowerCase()}`}>
                <td className="patient-cell">
                  <span className="patient-name">{apt.fullName}</span>
                  <span className="patient-phone">📞 {apt.phone}</span>
                </td>
                
                {/* Randevu Türü Kolonu */}
                <td className="type-cell">
                  <div className={`type-badge-mini ${apt.type === 'Online' ? 'type-online' : 'type-office'}`}>
                    {apt.type === 'Online' ? (
                      <><Video size={14} /> <span>Online</span></>
                    ) : (
                      <><Building2 size={14} /> <span>Klinik</span></>
                    )}
                  </div>
                </td>

                <td className="note-cell">
                  {editingNoteId === apt.id ? (
                    <div className="note-edit-area">
                      <textarea value={tempNote} onChange={(e) => setTempNote(e.target.value)} />
                      <button onClick={() => saveNote(apt.id)} className="save-note-btn">Kaydet</button>
                    </div>
                  ) : (
                    <div className="note-display" onClick={() => { setEditingNoteId(apt.id); setTempNote(apt.note || ""); }}>
                      <StickyNote size={14} /> {apt.note || "Not ekle..."}
                    </div>
                  )}
                </td>
                <td className="time-cell">
                  <span>📅 {apt.date}</span>
                  <span className="time-sub">⏰ {apt.time}</span>
                </td>
                <td>
                  <span className={`status-badge ${(apt.status === 'Onaylandı' ? 'approved' : 'pending')}`}>
                    {apt.status === 'Onaylandı' ? 'Onaylandı' : 'Beklemede'}
                  </span>
                </td>
                <td className="actions">
                  <div className="action-group">
                    {apt.status !== 'Onaylandı' && (
                      <button onClick={() => handleApprove(apt.id)} className="btn-modern btn-approve"><CheckCircle size={18} /></button>
                    )}
                    <button onClick={() => handleDelete(apt.id)} className="btn-modern btn-delete"><Trash2 size={18} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardView;